module.exports = __webpack_public_path__ + "media/images/admin/icons/monetization_on-0c0f258138c6d960466c7cc0675539ec.png";